// 顶部导航随 hero 幻灯片切换：
// 读取当前 slide 的 data-header-scheme（如 "color-scheme-4"）套到 .header-wrapper，整条导航
// （背景 + 文字 + 图标）随之翻转；并读取 data-header-logo / data-header-logo-mobile 切换导航 logo 图。
// 桌面 logo 改 <img> 的 src/srcset；移动 logo 改 <picture><source> 的 srcset；浏览器按视口自动选用。
// 不改动布局。
(function () {
  function init() {
    var slideshow = document.querySelector('slideshow-component');
    var header = document.querySelector('.header-wrapper');
    if (!slideshow || !header) return;

    var logo = header.querySelector('.header__heading-logo');
    var source = header.querySelector('.header__heading-logo-wrapper picture source');
    var defaultLogoSrc = logo ? logo.getAttribute('src') : null;
    var defaultLogoSrcset = logo ? logo.getAttribute('srcset') : null;
    var defaultSourceSrcset = source ? source.getAttribute('srcset') : null; // 默认移动 logo（logo-mobile.png）

    function applyLogo(url, mobileUrl) {
      // 桌面：<img>（移动视口下浏览器会改用 <source>，故这里只影响 ≥750px）
      if (logo) {
        if (url) {
          // srcset 优先级高于 src，必须一并覆盖，否则浏览器仍按响应式 srcset 用旧图
          logo.setAttribute('src', url);
          logo.setAttribute('srcset', url);
        } else {
          if (defaultLogoSrc) logo.setAttribute('src', defaultLogoSrc);
          if (defaultLogoSrcset) {
            logo.setAttribute('srcset', defaultLogoSrcset);
          } else {
            logo.removeAttribute('srcset');
          }
        }
      }
      // 移动：<picture><source>（media 命中时浏览器优先用它）
      if (source) {
        if (mobileUrl) {
          source.setAttribute('srcset', mobileUrl);
        } else if (defaultSourceSrcset) {
          source.setAttribute('srcset', defaultSourceSrcset);
        }
      }
    }

    function applyFromSlide(slide) {
      if (!slide) return;
      var scheme = slide.getAttribute('data-header-scheme'); // 例: "color-scheme-4"
      if (scheme) {
        header.className = header.className.replace(/\bcolor-scheme-\S+/g, '').trim();
        header.classList.add(scheme);
      }
      applyLogo(slide.getAttribute('data-header-logo'), slide.getAttribute('data-header-logo-mobile'));
    }

    // 初始状态用第一张幻灯片（slideChanged 仅在切换时触发，首屏需手动应用）
    applyFromSlide(slideshow.querySelector('.slideshow__slide'));

    slideshow.addEventListener('slideChanged', function (event) {
      applyFromSlide(event.detail.currentElement);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
